<template>
    <div class="text-center">
        <v-row>
            <v-col>
                <h2>Ferienverwaltung</h2>
                <p><small>
                    Ferien oder andere Ereignisse, die im Krümel Plan angezeigt werden sollen. <br>
                    Familiennamen bitte in der <router-link to="/user-manage">Benutzerverwaltung</router-link> pflegen.
                </small></p>
                <v-data-table
                    :headers="headers"
                    :items="holidays"
                    class="[ indigo  darken-2 ]"
                    dark
                    item-key="id"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:item.name="props">
                        <v-edit-dialog
                            large
                            persistent
                            cancel-text="Abbrechen"
                            save-text="Speichern"
                            @open="setUpdateVars(props.item)"
                            @save="updateHoliday(props.item.id)"
                        >
                            <div>{{ props.item.name }}</div>
                            <template v-slot:input>
                                <div class="mt-4 title">
                                    Namen bearbeiten
                                </div>
                                <v-text-field
                                    v-model="updateName"
                                    label="Name"
                                    single-line
                                    counter
                                    autofocus
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>
                    <template v-slot:item.start="props">
                        <v-edit-dialog
                            large
                            persistent
                            cancel-text="Abbrechen"
                            save-text="Speichern"
                            @open="setUpdateVars(props.item)"
                            @save="updateHoliday(props.item.id)"
                        >
                            <div>{{ props.item.start }}</div>
                            <template v-slot:input>
                                <div class="mt-4 title">
                                    Start bearbeiten
                                </div>
                                <v-text-field
                                    v-model="updateStart"
                                    label="Start"
                                    single-line
                                    counter
                                    autofocus
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>
                    <template v-slot:item.end="props">
                        <v-edit-dialog
                            large
                            persistent
                            cancel-text="Abbrechen"
                            save-text="Speichern"
                            @open="setUpdateVars(props.item)"
                            @save="updateHoliday(props.item.id)"
                        >
                            <div>{{ props.item.end }}</div>
                            <template v-slot:input>
                                <div class="mt-4 title">
                                    Ende bearbeiten
                                </div>
                                <v-text-field
                                    v-model="updateEnd"
                                    label="Ende"
                                    single-line
                                    counter
                                    autofocus
                                ></v-text-field>
                            </template>
                        </v-edit-dialog>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-dialog v-model="showDialog"
                  transition="dialog-bottom-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-row>
                    <v-col>
                        <v-btn
                            class="mx-2"
                            fab
                            dark
                            large
                            color="cyan"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon large>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
            <v-container class="white">
                <v-row>
                    <v-col
                        cols="12"
                        md="4">
                        <v-text-field label="Name" v-model="name"/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        cols="12"
                        md="4">
                        <label>Tag oder Zeitraum wählen</label>
                        <v-date-picker
                            v-model="dates"
                            range
                            locale="de"
                            :first-day-of-week="1"
                            header-color="[ indigo  darken-2 ]"
                            color="cyan"
                            class="mt-4"
                        ></v-date-picker>
                    </v-col>
                </v-row>
                <v-row class="text-center">
                    <v-col>
                        <v-btn
                            large
                            color="cyan"
                            dark
                            :loading="isSending"
                            @click="saveHoliday"
                        >
                            Eintragen
                        </v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </v-dialog>
    </div>
</template>

<script>
import HolidayService from '@/services/HolidayService'
import moment from 'moment'

export default {
    name: 'HolidayManage',
    data() {
        return {
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                {
                    text: 'Start',
                    align: 'start',
                    sortable: false,
                    value: 'start',
                },
                {
                    text: 'Ende',
                    align: 'start',
                    sortable: false,
                    value: 'end',
                }
            ],
            isSending: false,
            holidays: [],
            name: '',
            updateName: '',
            updateStart: '',
            updateEnd: '',
            showDialog: false,
            dates: null
        }
    },
    async created() {
        if (!this.isAdmin) {
            this.$router.push('/')
        }
        this.holidays = await HolidayService.getHolidays()
    },
    computed: {
        isAdmin() {
            return this.$store.getters.isAdmin
        },
        start() {
            return moment(this.dates[0]).format('DD.MM.YYYY')
        },
        end() {
            if (this.dates.length > 1) {
                return moment(this.dates[1]).format('DD.MM.YYYY')
            }
            return this.start
        }
    },
    methods: {
        async saveHoliday() {
            this.isSending = true
            try {
                await HolidayService.addHoliday(this.name, this.start, this.end)
                this.holidays = await HolidayService.getHolidays()
                this.showDialog = false
                this.name = ''
            } catch(error) {
                console.log('Error :/', error)
            }
            this.isSending = false
        },
        async updateHoliday(id) {
            try {
                await HolidayService.editHoliday(id, this.updateName, this.updateStart, this.updateEnd)
                this.holidays = await HolidayService.getHolidays()
                this.updateName = ''
                this.updateStart = ''
                this.updateEnd = ''
            } catch(error) {
                console.log('Error :/', error)
            }
        },
        setUpdateVars(item) {
            this.updateName = item.name
            this.updateStart = item.start
            this.updateEnd = item.end
        }
    }
}
</script>
